"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initDomoPassport = exports.DomoPassportDefault = void 0;
var _uuid = require("uuid");
var initDomoPassport = exports.initDomoPassport = function initDomoPassport() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    clientID: "",
    clientSecret: "",
    isConnected: false
  };
};
var DomoPassportDefault = exports.DomoPassportDefault = function DomoPassportDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    isConnected: false,
    clientID: "",
    clientSecret: ""
  };
};